import _api from '@/modules/campaigns/_api';

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {
    campaign: null,
  },
  // -----------------------------------------------------------------
  getters: {
    campaignSelected: (state,) => state.campaign,
  },
  // -----------------------------------------------------------------
  mutations: {
    setCampaign: (state, campaign,) => (state.campaign = campaign),
  },
  // -----------------------------------------------------------------
  actions: {
    updateCampaign: (_, { campaignId, input, },) => {
      return new Promise((resolve, reject,) => {
        _api.patch({ campaignId, input, },).then(() => {
          resolve();
        },).catch((error,) => {
          reject(error.response.data.errors,);
        },);
      },);
    },

    getCampaignDetails (_, campaignId,) {
      return _api.get({ _id: campaignId, },).then(
        (response,) => {
          return response.data;
        },
        (error,) => {
          return _api.handleError(error,);
        },
      );
    },

    getCampaignInfo (_, campaignId,) {
      return _api.campaignInfo(campaignId,).then(
        (response,) => {
          return response.data;
        },
        (error,) => {
          return _api.handleError(error,);
        },
      );
    },

    getBonds (_, _id,) {
      return _api.getBonds(_id,);
    },

    deleteImage (_, image,) {
      return _api.deleteImage(image,);
    },
  },
};
